/* eslint-disable prettier/prettier */
// import { debounce } from '../utils/index.js'
import debounce from "lodash/debounce";
import { DirectiveOptions } from 'vue';

interface Element extends HTMLElement {
  handler: () => void;
}

export default {
  bind(el: Element) {
    const element = el.querySelector('input') || el.querySelector('textarea')
    if (element) {
      el.handler = function () {
        element.value = element.value && element.value.trim()
        // 触发input事件
        const event = document.createEvent('HTMLEvents')
        event.initEvent('input', true)
        element.dispatchEvent(event)
      }
      element.addEventListener('change', debounce(el.handler, 300))
    }
  },
  unbind(el: Element) {
    const element = el.querySelector('input') || el.querySelector('textarea')
    if (element) {
      element.removeEventListener('change', el.handler)
    }
  },
} as unknown as DirectiveOptions;
